var exports = {
  "kL": "container__7KVaZF",
  "zC": "messageContainer__yBRvVi",
  "H": "avatarContainer__LRAa0V",
};

module.exports = exports;
